export const urlBase = '/api';
export const urlUsers = `${urlBase}/usuarios`;
export const urlStudents = `${urlBase}/students`;
export const urlAssistances = `${urlBase}/assistances`;
export const urlStudentSubjects = `${urlBase}/studentsubjects`;
export const urlExams = `${urlBase}/exams`;
export const urlPeriodos = `${urlBase}/Periodos`;
export const urlMateriasPeriodo = `${urlBase}/MateriasPeriodo`;
export const urlPlanning = `${urlBase}/planning`;
export const urlInscripcionExamen = `${urlBase}/inscripcionexamen`;
export const urlFacultades = `${urlBase}/facultades`;
export const urlCarreras = `${urlBase}/carreras`;
export const urlMaterias = `${urlBase}/materias`;
export const urlCorrelativas = `${urlBase}/materias/correlativas`;
export const urlMallas = `${urlBase}/mallas`;
export const urlProfessors = `${urlBase}/Professors`;
export const urlContentRecords = `${urlBase}/content-record`;
export const urlExamReviewRequests = `${urlBase}/exam-review-requests`;
